/**
 * @generated SignedSource<<3ebcdaebf5f5a2b736fc14fd75b77e50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PaymentMethodType = "ACH" | "AFFIRM_CREDIT_CARD" | "APPLE_PAY" | "APPLIED_SALE" | "CASH" | "CHECK" | "CREDIT_CARD" | "CREDIT_TO_USER_ACCOUNT" | "DIRECT_PAYMENT" | "DISCOUNT" | "HYPERWALLET" | "KLARNA" | "ON_PLATFORM_WIRE_TRANSFER" | "OTHER" | "PAYPAL_ACCOUNT" | "PAY_LATER" | "UNKNOWN" | "WIRE_TRANSFER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PayPalPaymentMethod_buyer$data = {
  readonly serviceId: string | null;
  readonly wallet: {
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly email?: string | null;
        readonly paymentMethodType: PaymentMethodType | null;
        readonly token?: string | null;
      } | null;
      readonly shippingAddresses: ReadonlyArray<{
        readonly serviceId: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PayPalPaymentMethod_buyer";
};
export type PayPalPaymentMethod_buyer$key = {
  readonly " $data"?: PayPalPaymentMethod_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PayPalPaymentMethod_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PayPalPaymentMethod_buyer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "wallet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletPaymentMethod",
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Address",
              "kind": "LinkedField",
              "name": "shippingAddresses",
              "plural": true,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paymentMethodType",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "token",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    }
                  ],
                  "type": "PayPalAccount",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "72ff0ee98062bde661259a601b41524c";

export default node;
